export const TRANSLATIONS: string = "TRANSLATIONS";
export const TRANSLATIONS_SUCCESS: string = "TRANSLATIONS_SUCCESS";
export const TRANSLATIONS_ERROR: string = "TRANSLATIONS_ERROR";

export const TRANSLATIONS_SET_LOCALE: string = "TRANSLATIONS_SET_LOCALE";
